<script>
export default {
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputText: '',
    };
  },
  methods: {
    addEmail(raw) {
      const email = raw.trim().replace(/,$/, '').trim();
      if (!email) return;
      if (this.modelValue.includes(email)) {
        this.inputText = '';
        return;
      }
      this.$emit('update:modelValue', [...this.modelValue, email]);
      this.inputText = '';
    },
    onKeydown(e) {
      if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
        e.preventDefault();
        this.addEmail(this.inputText);
      } else if (e.key === 'Backspace' && !this.inputText && this.modelValue.length) {
        this.$emit('update:modelValue', this.modelValue.slice(0, -1));
      }
    },
    onBlur() {
      if (this.inputText.trim()) {
        this.addEmail(this.inputText);
      }
    },
    onPaste(e) {
      e.preventDefault();
      const pasted = (e.clipboardData || window.clipboardData).getData('text');
      const emails = pasted.split(/[\s,;]+/).filter(Boolean);
      if (emails.length > 1) {
        const next = [...new Set([...this.modelValue, ...emails])];
        this.$emit('update:modelValue', next);
      } else {
        this.inputText += pasted;
      }
    },
    remove(index) {
      const next = this.modelValue.filter((_, i) => i !== index);
      this.$emit('update:modelValue', next);
    },
    focusInput() {
      this.$refs.input?.focus();
    },
  },
};
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-1 px-2 py-1.5 min-h-9 bg-n-alpha-1 rounded-lg outline outline-1 outline-n-weak dark:outline-n-strong cursor-text focus-within:outline-woot-500"
    @click="focusInput"
  >
    <span
      v-for="(email, i) in modelValue"
      :key="email"
      class="flex items-center gap-1 px-2 py-0.5 text-xs rounded-full bg-woot-100 dark:bg-woot-800 text-woot-700 dark:text-woot-200"
    >
      {{ email }}
      <button
        type="button"
        class="hover:text-n-ruby-11 leading-none"
        @click.stop="remove(i)"
      >
        <i class="i-lucide-x text-xs" />
      </button>
    </span>
    <input
      ref="input"
      v-model="inputText"
      type="email"
      class="flex-1 min-w-24 bg-transparent text-sm outline-none placeholder:text-n-slate-9"
      :placeholder="modelValue.length ? '' : placeholder"
      @keydown="onKeydown"
      @blur="onBlur"
      @paste="onPaste"
    />
  </div>
</template>
